import React, { useState, useEffect } from 'react';
import { SITE_CONFIG } from '../data';
import './Countdown.css';

function getTimeLeft() {
  const diff = SITE_CONFIG.eventDate - new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days:    Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours:   Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

export default function Countdown() {
  const [t, setT] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => setT(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  const units = [
    { label: 'Gün',     value: t.days    },
    { label: 'Saat',    value: t.hours   },
    { label: 'Dakika',  value: t.minutes },
    { label: 'Saniye',  value: t.seconds },
  ];

  return (
    <div className="countdown-wrap">
      <p className="countdown-label">Etkinliğe Kalan Süre</p>
      <div className="countdown-grid">
        {units.map(({ label, value }, i) => (
          <React.Fragment key={label}>
            {i > 0 && <span className="cd-sep">:</span>}
            <div className="countdown-unit">
              <span className="countdown-number">{String(value).padStart(2, '0')}</span>
              <span className="countdown-unit-label">{label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
      <p className="countdown-date">
        {SITE_CONFIG.eventDate.toLocaleDateString('tr-TR', {
          day: 'numeric', month: 'long', year: 'numeric',
        })}
      </p>
    </div>
  );
}
